import { useCreateAppointment } from '../../../entities/appointment'
import { CalendarPlanningOverlay } from '../../calendar-planning-overlay'

const FOLLOW_UP_COLORS = { work: '#F97316', travel: '#FB923C' }

interface Props {
  show: boolean
  onClose: () => void
  onSuccess: () => void
  workOrderId: string
  technicianId: number
}

export function WorkerAppointmentPlanOverlay({
  show,
  onClose,
  onSuccess,
  workOrderId,
  technicianId,
}: Props) {
  const createAppointment = useCreateAppointment()

  return (
    <CalendarPlanningOverlay
      show={show}
      onClose={onClose}
      technicianId={technicianId}
      resetOnShow
      headerTitle="Folgetermin planen"
      saveButtonColor="#F97316"
      draftTitle="Folgetermin"
      draftColors={FOLLOW_UP_COLORS}
      hintText="Tippe auf eine Uhrzeit im Kalender, um den Folgetermin zu setzen"
      onSave={async (payload) => {
        await createAppointment.mutateAsync({
          workOrderId,
          assignedTechnicianId: technicianId,
          plannedStart: payload.plannedStart,
                  plannedWorkDuration: payload.plannedWorkDuration,
          plannedTravelDuration: payload.plannedTravelDuration,
          plannedDepartureDuration: payload.plannedDepartureDuration,
          attachments: null,
        })
        onSuccess()
      }}
      isPending={createAppointment.isPending}
    />
  )
}
